import { render, staticRenderFns } from "./r-smart-offer-bundle-market.vue?vue&type=template&id=4723e3ed"
import script from "./r-smart-offer-bundle-market.vue?vue&type=script&lang=js"
export * from "./r-smart-offer-bundle-market.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4723e3ed')) {
      api.createRecord('4723e3ed', component.options)
    } else {
      api.reload('4723e3ed', component.options)
    }
    module.hot.accept("./r-smart-offer-bundle-market.vue?vue&type=template&id=4723e3ed", function () {
      api.rerender('4723e3ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-market/r-smart-offer-bundle-market.vue"
export default component.exports